import React, { createContext, useContext } from "react";

// Presence tracking simplified — can add WebSocket/polling later if needed
interface PresenceData {
  userId: string;
  route: string;
  online: boolean;
  lastActive: any;
}

interface PresenceContextValue {
  presenceData: PresenceData | null;
}

const PresenceContext = createContext<PresenceContextValue | undefined>(
  undefined
);

export const PresenceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // TODO: implement via WebSocket or polling to /api/presence
  return (
    <PresenceContext.Provider value={{ presenceData: null }}>
      {children}
    </PresenceContext.Provider>
  );
};

export const usePresence = () => {
  const context = useContext(PresenceContext);
  if (!context) {
    throw new Error("usePresence must be used within a PresenceProvider");
  }
  return context;
};
